import React from 'react';

const Hero = () => {
  // Your updated partners list with names and logos from the public folder
  const partners = [
    { name: "Millennium Challenge Corporation", logo: "/mcc-logo.png" },
    { name: "USAID / United Purpose", logo: "/usaid-logo.png" },
    { name: "GIZ", logo: "/giz-logo.png" },
    { name: "European Union", logo: "/eu-logo.png" }
  ];

  return (
    <div id="about">
      {/* 1. MAIN HERO SECTION (Keeps the Blue Background) */}
      <section className="relative bg-blue-900 text-white pt-24 pb-20 px-6 overflow-hidden">
        {/* Background Decorative Element */}
        <div className="absolute top-0 right-0 -mt-20 -mr-20 opacity-10">
          <svg width="400" height="400" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="2" fill="none" />
          </svg>
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="inline-block bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-6 uppercase tracking-wider">
            Established 2022
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight">
            Excellence in Engineering & <br/> 
            <span className="text-green-400">Sustainable Development</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100 italic font-light">
            Diagnose | Co-Innovate | Transform
          </p>
          <p className="text-lg text-blue-100 max-w-2xl mb-12 leading-relaxed">
            Working with communities and organizations to promote sustainable economic and social development across Malawi.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-2">
            <a href="#projects" className="bg-white text-blue-900 px-8 py-3 rounded-md font-bold text-center hover:bg-gray-100 transition shadow-lg">
              View Our Experience
            </a>
            <a href="#services" className="border border-blue-400 text-white px-8 py-3 rounded-md font-bold text-center hover:bg-blue-800 transition">
              Our Services
            </a>
          </div>
        </div>
      </section>

      {/* 2. THE NEW "TRUSTED BY" BAR (Now on a clean, spaced white background) */}
      <section className="bg-white py-12 px-6 border-b border-gray-100 shadow-inner">
        <div className="max-w-7xl mx-auto">
          <p className="text-center text-xs font-semibold text-gray-500 uppercase tracking-[0.2em] mb-10">
            Trusted by International Partners & Organizations
          </p>
          
          {/* Spacing and Alignment Fix: flex flex-wrap justify-around items-center gap-12 */}
          <div className="flex flex-wrap justify-around items-center gap-12 md:gap-16">
            {partners.map((partner, index) => (
              <div key={index} className="flex flex-col items-center gap-4 group transition-all duration-300">
                {/* Logo with perfect spacing */}
                <div className="h-16 flex items-center justify-center p-2">
                  <img 
                    src={partner.logo} 
                    alt={partner.name} 
                    className="h-full w-auto object-contain transition duration-300 hover:scale-110" 
                  />
                </div>
                {/* The Partner Name is Back! Spaced below the logo */}
                <span className="text-xs font-bold text-blue-900 text-center uppercase tracking-wider opacity-60 group-hover:opacity-100 transition max-w-[150px] leading-tight">
                  {partner.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;